import { useEffect, useRef, useState } from "react";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import {
  materialInward,
  rawMaterials,
  supplierDieAPI,
  Unit,
} from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import EntityAddModal from "../../common/EntityAddModal";
import Button from "../../common/Button";
import { formatDate } from "../../utlis/formateDate";

const MaterialInward = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    inward_No: 0,
    inward_Date: today,
    skU_No: "",
    supplier_Id: "",
    material_Id: "",
    weight_Sleep1: "",
    weight_Sleep2: "",
    quantity: "",
    unit_Id: "",
    rate: "",
    origin: "",
    invoice_No: "",
    grade: "",
    batch_No: "",
    vehicle_No: "",
    notes: "",
    image_Upload: null,
    created_By: userId,
  });

  const [loading, setLoading] = useState(false);
  const [isMaterialInwardData, setIsMaterialInwardData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isSupplierData, setIsSupplierData] = useState([]);
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isUnitData, setIsUnitData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;
  const [modalType, setModalType] = useState(null);
  const tableScrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);

  const fetchInwardData = async () => {
    if (isFetchingRef.current) return;
    setLoading(true);
    try {
      const res = await materialInward.getAllmaterialInward(
        currentPage,
        pageSize,
      );
      if (currentPage === 1) {
        setIsMaterialInwardData(res.items || []);
      } else {
        setIsMaterialInwardData((prev) => [...prev, ...(res.items || [])]);
      }

      if (!res.items || res.items.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching die master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 120) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [rawMaterialRes, supplierRes, unitRes] = await Promise.all([
          rawMaterials.getAll(),
          supplierDieAPI.getAll(),
          Unit.getAll(),
        ]);

        setIsRawMaterialData(
          Array.isArray(rawMaterialRes)
            ? rawMaterialRes
            : rawMaterialRes?.data || [],
        );

        const supplierArray = Array.isArray(supplierRes?.data)
          ? supplierRes.data
          : [];
        setIsSupplierData(supplierArray);

        setIsUnitData(Array.isArray(unitRes) ? unitRes : unitRes?.data || []);
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    fetchInwardData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isMaterialInwardData);
    } else {
      const filtered = isMaterialInwardData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isMaterialInwardData]);

  const handleInputChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAdd = () => {
    setIsModelOpen(true);
    setIsEditing(false);
    setFormData({
      inward_No: 0,
      inward_Date: today,
      skU_No: "",
      supplier_Id: "",
      material_Id: "",
      weight_Sleep1: "",
      weight_Sleep2: "",
      quantity: "",
      unit_Id: "",
      rate: "",
      origin: "",
      invoice_No: "",
      grade: "",
      batch_No: "",
      vehicle_No: "",
      notes: "",
      image_Upload: null,
      created_By: userId,
    });
  };

  const handleEdit = async (id) => {
    try {
      const data = await materialInward.getById(id);

      if (data) {
        setFormData({
          inward_No: data.inward_No,
          inward_Date: data.inward_Date?.split("T")[0],
          skU_No: data.skU_No,
          supplier_Id: data.supplier_Id,
          material_Id: data.material_Id,
          weight_Sleep1: data.weight_Sleep1,
          weight_Sleep2: data.weight_Sleep2,
          quantity: data.quantity,
          unit_Id: data.unit_Id,
          rate: data.rate,
          origin: data.origin,
          invoice_No: data.invoice_No,
          grade: data.grade,
          batch_No: data.batch_No,
          vehicle_No: data.vehicle_No,
          notes: data.notes,
          image_Upload: data.image_Upload,
          created_By: userId,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await materialInward.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchInwardData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    try {
      const payload = {
        ...formData,
        material_Id: parseInt(formData.material_Id),
        supplier_Id: parseInt(formData.supplier_Id),
        unit_Id: parseInt(formData.unit_Id),
      };
      await materialInward.saveOrUpdate(payload);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success",
      );
      fetchInwardData();
      setFormData("");
      setIsEditing(false);
      if (!resetOnly) {
        setIsModelOpen(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    }
  };

  const fields = [
    { label: "Basic Information", type: "section" },
    {
      name: "inward_Date",
      label: "Inward Date",
      type: "date",
      required: true,
      grid: "col-span-12 sm:col-span-4",
      errorMessage: "Date is required",
    },
    {
      name: "skU_No",
      label: "SKU No",
      type: "text",
      readOnly: true,
      grid: "col-span-12 sm:col-span-4",
    },
    {
      name: "invoice_No",
      label: "Invoice No",
      type: "text",
      grid: "col-span-12 sm:col-span-4",
    },
    {
      name: "supplier_Id",
      label: "Supplier Name",
      type: "selectWithAdd",
      required: true,
      grid: "col-span-12 sm:col-span-6",
      options: isSupplierData?.map((s) => ({
        value: s.supplier_Id,
        label: s.supplier_Name,
      })),
      onAddNew: () => setModalType("supplier"),
      errorMessage: "Supplier Name is required",
    },
    {
      name: "material_Id",
      label: "Material Name",
      type: "selectWithAdd",
      required: true,
      grid: "col-span-12 sm:col-span-6",
      options: isRawMaterialData?.map((s) => ({
        value: s.id,
        label: s.name,
      })),
      onAddNew: () => setModalType("rawMaterial"),
      errorMessage: "Material Name is required",
    },

    { label: "Material Details & Weight", type: "section" },
    {
      name: "quantity",
      label: "Quantity",
      type: "number",
      required: true,
      grid: "col-span-12 sm:col-span-3",
      errorMessage: "Quantity is required",
    },
    {
      name: "unit_Id",
      label: "Unit",
      type: "selectWithAdd",
      required: true,
      grid: "col-span-12 sm:col-span-3",
      options: isUnitData?.map((s) => ({
        value: s.unit_Id,
        label: s.unit_Name,
      })),
      onAddNew: () => setModalType("unit"),
    },
    {
      name: "rate",
      label: "Rate",
      type: "number",
      required: true,
      grid: "col-span-12 sm:col-span-3",
    },
    {
      name: "grade",
      label: "Grade",
      type: "text",
      grid: "col-span-12 sm:col-span-3",
    },
    {
      name: "weight_Sleep1",
      label: "Weight Slip 1",
      type: "text",
      grid: "col-span-12 sm:col-span-6",
    },
    {
      name: "weight_Sleep2",
      label: "Weight Slip 2",
      type: "text",
      grid: "col-span-12 sm:col-span-6",
    },

    { label: "Logistics & Additional Info", type: "section" },
    {
      name: "vehicle_No",
      label: "Vehicle No",
      type: "text",
      grid: "col-span-12 sm:col-span-4",
    },
    {
      name: "batch_No",
      label: "Batch No",
      type: "text",
      grid: "col-span-12 sm:col-span-4",
    },
    {
      name: "origin",
      label: "Origin",
      type: "text",
      grid: "col-span-12 sm:col-span-4",
    },
    {
      name: "notes",
      label: "Notes",
      type: "textarea",
      grid: "col-span-12 sm:col-span-12",
    },
    {
      name: "image_Upload",
      label: "Image Upload",
      type: "image",
      grid: "col-span-12 sm:col-span-4",
    },
  ];

  const optionMap = {
    supplier: {
      setter: setIsSupplierData,
      fetcher: supplierDieAPI.getAll,
      mapFn: (data) =>
        data?.map((c) => ({
          value: c.supplier_Id,
          label: c.supplier_Name,
        })),
      setField: "supplier_Id",
    },
    rawMaterial: {
      setter: setIsRawMaterialData,
      fetcher: rawMaterials.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.id,
          label: s.name,
        })),
      setField: "id",
    },
    unit: {
      setter: setIsUnitData,
      fetcher: Unit.getAll,
      mapFn: (data) =>
        data?.map((s) => ({
          value: s.unit_Id,
          label: s.unit_Name,
        })),
      setField: "unit_Id",
    },
  };

  const handleEntityAddSuccess = async (type, newOption) => {
    const config = optionMap[type];
    if (!config) return;

    try {
      const response = await config.fetcher();
      const items = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      config.setter(items);

      setFormData((prev) => ({
        ...prev,
        [config.setField]: newOption?.value || "",
      }));
      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const generateSupplierInitials = (name) => {
    if (!name || !name.trim()) return "SUPP";
    const initials = name
      .split(" ")
      .map((word) => word[0] || "")
      .join("")
      .toUpperCase()
      .slice(0, 4);
    return initials || "SUPP";
  };

  const formatDateForSku = (isoDate) => {
    try {
      const d = new Date(isoDate);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      return `${day}${month}`;
    } catch {
      return "XXXX";
    }
  };

  const formatInvoiceForSku = (invoiceNo) => {
    if (!invoiceNo || !invoiceNo.trim()) return "";
    const match = invoiceNo.replace(/[^0-9]/g, "");
    return match ? `-${match}` : "";
  };

  const generateScrapSku = (supplierName, dateReceivedIso, invoiceNo) => {
    const initials = generateSupplierInitials(supplierName);
    const datePart = formatDateForSku(dateReceivedIso);
    const invoicePart = formatInvoiceForSku(invoiceNo);
    return `${initials}${datePart}${invoicePart}`;
  };

  useEffect(() => {
    const supplierObj = isSupplierData.find(
      (s) => String(s.supplier_Id) === String(formData.supplier_Id),
    );

    if (supplierObj && formData.inward_Date) {
      const sku = generateScrapSku(
        supplierObj.supplier_Name,
        formData.inward_Date,
        formData.invoice_No,
      );
      setFormData((prev) => ({
        ...prev,
        skU_No: sku,
      }));
    }
  }, [formData.supplier_Id, formData.inward_Date, formData.invoice_No]);

  return (
    <>
      <div>
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
          <div className="flex flex-col">
            <h2 className="text-2xl font-extrabold text-gray-800 tracking-tight">
              Material Inward
            </h2>
            <p className="text-sm text-gray-500">
              Manage and track customer sales orders
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
            <div className="relative w-full sm:w-72 group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LiaSearchSolid className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
              </div>
              <input
                type="text"
                placeholder="Search by Order No..."
                className="block w-full pl-10 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-red-500 transition-colors"
                >
                  <MdClose size={18} />
                </button>
              )}
            </div>

            <Button
              text="Add Material Inward"
              className="bg-orange text-black hover:bg-white font-medium px-4 py-2 rounded-lg flex items-center shadow-sm transition-all"
              icon={HiOutlinePlus}
              onClick={handleAdd}
            />
          </div>
        </div>
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-slate-200 rounded-xl shadow-inner bg-white"
          style={{ height: "calc(100vh - 260px)" }}
        >
          {loading && currentPage === 1 ? (
            <Loader />
          ) : (
            <div className="min-w-max">
              <Table
                columns={[
                  {
                    key: "inward_Date",
                    label: "Inward Date",
                    render: (value) => formatDate(value),
                  },
                  { key: "skU_No", label: "SKU No" },
                  { key: "supplier_Name", label: "Supplier" },
                  { key: "material_Name", label: "Material" },
                  { key: "quantity", label: "Quantity" },
                  { key: "unit_Name", label: "Unit" },
                  { key: "rate", label: "Rate" },
                  { key: "origin", label: "Origin" },
                  { key: "invoice_No", label: "Invoice No" },
                  { key: "grade", label: "Grade" },
                  { key: "batch_No", label: "Batch No" },
                  { key: "vehicle_No", label: "Vehicle No" },
                  { key: "notes", label: "notes" },
                ]}
                data={filteredData}
                onEdit={(row) => handleEdit(row.inward_No)}
                onDelete={(row) => handleDelete(row.inward_No)}
              />
            </div>
          )}
        </div>
      </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Material Inward" : "Add Material Inward"}
      >
        <FormFields
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: false });
          }}
          onSubmitAndAddNew={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: true });
          }}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={fields}
          isEditing={isEditing}
          onClear={() => setIsModelOpen(false)}
        />
      </Model>
      <Model
        isOpen={!!modalType}
        onClose={() => setModalType(null)}
        name={`Add ${modalType}`}
      >
        <EntityAddModal
          type={modalType}
          onClose={(newOption) => {
            setModalType(null);
            handleEntityAddSuccess(modalType, newOption);
          }}
        />
      </Model>
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default MaterialInward;
